import React from 'react';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { dispatchTrackingEvent, LOYALTY_CLICK } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

function Loyalty({ data }) {
    const handleLinkClick = (buttonText) => {
        if (!IS_FRAME_SERVICE) dispatchTrackingEvent(LOYALTY_CLICK, { loyaltyType: buttonText });
    };

    return (
        data && (
            <div className="loyalitySection">
                <div className="loyalitySectionInner">
                    <div className="loyalitySectionInner--header">
                        <h4>{data.title}</h4>
                        <p>{data.text}</p>
                    </div>
                    <a
                        href={data.buttonOne.hyperlink.redirectURL}
                        title={data.buttonOne.hyperlink.seoTitle}
                        className="loyalitySectionLink loyalitySectionLink--left"
                        onClick={() => handleLinkClick(data.buttonOne.text)}
                    >
                        {data.buttonOne.hyperlink.redirectURLTitle}
                        <span>{data.buttonOne.text}</span>
                    </a>
                    <a
                        href={data.buttonTwo.hyperlink.redirectURL}
                        title={data.buttonTwo.hyperlink.seoTitle}
                        className="loyalitySectionLink loyalitySectionLink--right"
                        onClick={() => handleLinkClick(data.buttonTwo.text)}
                    >
                        {data.buttonTwo.hyperlink.redirectURLTitle}
                        <span>{data.buttonTwo.text}</span>
                    </a>
                </div>
            </div>
        )
    );
}

export default Loyalty;
